<template>
  <div class="menuFrame" v-if="show">
    <loading :active.sync="isLoading"></loading>

    <div class="container py-1">
      <div class="row flex-nowrap pt-3 mx-2 justify-content-between align-items-center">
        <!-- <a href="https://www.chanchao.com.tw/"> -->
        <div class="d-flex">
          <img src="../assets/images/ChanChaoLogo.png" class="navLogo mt-2" />
          <div class="ml-2 mt-1 mt-md-0">
            <div class="navHead font-weight-nomal">展昭會員</div>
            <div class="text-muted navCnt">ChanChao Member</div>
          </div>
        </div>
        <!-- </a> -->

        <!-- <div class="d-flex mr-3">
          <router-link to="/en/login">
            <img src="../assets/images/lang.svg" style="width: 17px; height: 17px" />

            <span class="navEnText text-muted ml-1"> English Version </span>
          </router-link>
        </div> -->
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center formFrame m-1 py-2">
        <div class="col-md-7 my-4 px-4">
          <div class="d-flex justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <img src="../assets/images/loginIcon.png" class="mr-2" style="width: 40px; height: 40px" alt="" />
              <div style="font-size: 22px" class="font-weight-bold">展昭會員帳號綁定</div>
            </div>
          </div>

          <hr />

          <div class="form-check bg-light font-weight-bold" style="font-size: 18px">
            <div class="d-flex align-items-center">
              <input
                class="form-check-input bg-light mx-1 mb-1"
                type="radio"
                name="exampleRadios"
                id="exampleRadios1"
                value="Login"
                v-model="SelectMethod"
              />
              <div>
                <label class="form-check-label p-3 ml-2 pointer" for="exampleRadios1">
                  我已是展昭會員(登入即完成綁定)
                </label>
              </div>
            </div>
          </div>

          <div class="ml-5">
            <div class="mt-3 mb-4" style="font-size: 17px">
              <span class="mr-2">
                <img src="../assets/images/LINE_logo.png" style="width: 20px; height: 20px" alt="" />
              </span>

              <span>LINE連動帳號 : {{ LineUserName }}</span>
            </div>

            <form>
              <div class="form-group">
                <label for="loginEmail">電子郵件地址</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  maxlength="50"
                  placeholder="請輸入您註冊時的電子郵件"
                  id="loginEmail"
                  aria-describedby="emailHelp"
                  :class="{ 'is-invalid': errors.first('email') }"
                  v-validate="'required|email'"
                  v-model="email"
                  ref="loginEmail"
                />
                <span class="text-danger" style="font-size: 10px" v-if="errors.first('email')"
                  >{{ errors.first('email') }}
                </span>
              </div>
              <div class="form-group">
                <label for="loginPassword">
                  密碼 (
                  <a href="https://www.chanchao.com.tw/accounts/forgetPw" target="_blank"> 忘記密碼或重設密碼 </a>)
                </label>
                <div class="input-group mb-3">
                  <input
                    :type="typePwd"
                    class="form-control"
                    name="password"
                    id="loginPassword"
                    autocomplete="off"
                    placeholder="請輸入您設定的密碼"
                    maxlength="20"
                    :class="{ 'is-invalid': errors.first('password') }"
                    v-model="password"
                    v-validate="'required'"
                    ref="loginPassword"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                      <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                      <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                    </span>
                  </div>
                </div>
                <span class="text-danger" style="font-size: 10px" v-if="errors.first('password')"
                  >密碼欄位不能留空
                </span>
              </div>

              <div class="form-group">
                <label for="loginPassword2">驗證碼</label>
                <div class="d-flex justify-content-around align-items-center">
                  <input
                    type="text"
                    name="text"
                    maxlength="5"
                    placeholder="驗證碼不分大小寫"
                    class="form-control mr-1"
                    id="loginPassword2"
                    v-model="Validcode"
                    :class="{ 'is-invalid': errors.first('text') }"
                    v-validate="'required'"
                    ref="loginPassword2"
                  />
                  <img
                    :src="getsrc"
                    class="img-fluid rounded"
                    @click.prevent="resetValidcode"
                    style="width: 120px; height: 35px"
                  />
                  <a href="#" @click.prevent="resetValidcode">
                    <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                  </a>
                </div>
                <span class="text-danger" style="font-size: 10px" v-if="errors.first('text')">驗證碼欄位不能留空 </span>
              </div>
            </form>
          </div>

          <div class="form-check bg-light font-weight-bold mt-4" style="font-size: 18px">
            <div class="d-flex align-items-center">
              <input
                class="form-check-input bg-light mx-1 mb-1"
                type="radio"
                name="exampleRadios"
                id="exampleRadios2"
                value="Signup"
                v-model="SelectMethod"
                checked
              />
              <div>
                <label class="form-check-label p-3 ml-2 pointer" for="exampleRadios2">
                  我還不是展昭會員，我要同時註冊成為新會員
                </label>
              </div>
            </div>
          </div>

          <div class="ml-5">
            <div class="mt-3 mb-4" style="font-size: 17px">
              <span class="mr-2">
                <img src="../assets/images/LINE_logo.png" style="width: 20px; height: 20px" alt="" />
              </span>

              <span>LINE連動帳號 : {{ LineUserName }}</span>
            </div>
          </div>
          <hr />

          <div class="d-flex justify-content-center">
            <div class="btn btn-primary mt-2 d-inline-block d-flex justify-content-center px-4" @click="SubmitBtn">
              確定送出
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Footer from '@/components/footer.vue'

  export default {
    components: {
      Footer,
    },
    data() {
      return {
        SelectMethod: 'Login',

        getsrc: '',
        typePwd: 'password',
        email: '',
        password: '',
        Validcode: '',
        LineUserName: '',
        CSRF_Token: '',

        lastUrl: '',
        getLineID: '',

        // isLoading: true,
        show: false,
      }
    },

    methods: {
      SubmitBtn() {
        const vm = this

        if (vm.SelectMethod == 'Login') {
          const url = 'https://www.chanchao.com.tw/apiLogin2/Login'
          const info = {
            login: vm.email,
            password: vm.password,
            Validcode: vm.Validcode,
            CSRF: vm.CSRF_Token,
            verifycode: vm.getLineID,
          }

          // console.log(info)

          vm.$validator.validate().then((valid) => {
            if (valid) {
              vm.$http.post(url, info).then(function (response) {
                // console.log(response)
                if (response.data == '200') {
                  if (vm.lastUrl) {
                    vm.$cookies.remove('url')
                    window.location.replace(vm.lastUrl)
                  } else {
                    window.location.replace('https://www.chanchao.com.tw/')
                  }
                } else if (response.data == '252') {
                  vm.alertText = '您的郵件地址輸入錯誤！'
                  vm.alertError()
                  vm.$refs.loginEmail.style.borderColor = 'red'
                } else if (response.data == '253') {
                  vm.alertText = '您的密碼輸入錯誤！'
                  vm.alertError()
                  vm.$refs.loginPassword.style.borderColor = 'red'
                } else if (response.data == '254') {
                  vm.alertText = '您的驗證碼輸入錯誤！'
                  vm.alertError()
                  vm.$refs.loginPassword2.style.borderColor = 'red'
                } else if (response.data == '255') {
                  window.location.replace('https://www.chanchao.com.tw/')
                } else if (response.data == '257') {
                  alert('您的LINE綁定程序逾時，請再次登入')
                  window.location.replace('https://www.chanchao.com.tw/accounts/login')
                } else if (response.data == '258') {
                  alert('請在您的瀏覽器中啟用cookie並再次登入。')
                  window.location.replace('https://www.chanchao.com.tw/accounts/login')
                } else {
                  vm.alertText = '系統忙碌，請稍後登入！'
                  vm.alertError()
                }
              })
            } else {
              vm.alertText = '輸入欄位不完整，請重新檢查！'
              vm.alertError()
            }
          })
        } else if (vm.SelectMethod == 'Signup') {
          vm.$router.push({ path: `/signup_line` })
        }
      },

      alertError() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },
    },

    created() {
      let lastPage = document.referrer

      console.log(lastPage)

      let Getcode = this.$route.query.code
      let Getstate = this.$route.query.state
      let Geterror = this.$route.query.error
      let Geterror_description = this.$route.query.error_description

      if (Geterror == undefined) {
        Geterror = ''
      }

      if (Geterror_description == undefined) {
        Geterror_description = ''
      }

      const vm = this

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //取得上頁網址(from cookie)

      // vm.lastUrl = sessionStorage.getItem('url')
      vm.lastUrl = vm.$cookies.get('url')
      // console.log(vm.lastUrl)

      //取得line用戶名稱(from Session)
      vm.LineUserName = sessionStorage.getItem('LineName')

      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiLine/LineLogin/AfterLineLogin?code=${Getcode}&state=${Getstate}&error=${Geterror}&error_description=${Geterror_description}`
        )
        .then((res) => {
          if (res.data.code == 251) {
            vm.show = true
            vm.LineUserName = res.data.data.displayName
            sessionStorage.setItem('LineName', vm.LineUserName)
            vm.getLineID = res.data.data.userId
            vm.$store.dispatch('SaveLineId', vm.getLineID)
          } else if (res.data.code == 200) {
            // alert('使用者已完成LINE串接，可直接進入展昭網站(導入網址 / 會員中心)')
            vm.$cookies.remove('url')
            if (vm.lastUrl) {
              window.location.replace(vm.lastUrl)
            } else {
              window.location.replace('https://www.chanchao.com.tw/member')
            }
          } else if (res.data.code == 401) {
            alert('重複授權失敗，請再次登入')
            // alert(Getcode)
            // alert(Getstate)

            history.back()
          } else if (res.data.code == 500) {
            alert('您的LINE綁定程序逾時，請再次登入')
            // window.location.replace('https://www.chanchao.com.tw/accounts/login')
            history.back()
          } else if (res.data.code == 252) {
            vm.$cookies.remove('url')
            if (vm.lastUrl) {
              window.location.replace(vm.lastUrl)
            } else {
              window.location.replace('https://www.chanchao.com.tw/member')
            }
          }
        })
    },
  }
</script>

<style lang="scss" scoped>
  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 10px;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .lineRight {
    border-right: 1px solid #ccc;
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navHead {
    font-size: 29px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 17px;
  }

  .navLogo {
    height: 55px;
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  .linkFrame {
    font-size: 15px;
  }

  .linkText {
    position: relative;
  }

  .linkLine {
    position: absolute;
    height: 13px;
    //width: 33px;
    top: 20%;
    left: 0;
    border-left: 2px solid #a1a7a8;
  }

  .pointer {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .lineRight {
      border-right: 0px;
    }

    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
      padding-top: 30px;
    }

    .navEnText {
      display: none;
    }

    .navHead {
      font-size: 23px;
      color: #2c3e50;
    }

    .navCnt {
      font-size: 14px;
    }

    .navLogo {
      height: 50px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
</style>
